// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"41":"59ac9df1","218":"2f7f26d4"}[chunkId] + ".js";
};